import { BaseError } from "../base/BaseError";

export class UnAuthorizedError extends BaseError {
    message = "لا يمكن إتمام الطلب لعدم امتلاك الصلاحيات اللازمة";
}
